/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close-button[_ngcontent-%COMP%]{cursor:pointer;font-size:1.5rem;position:absolute;top:10px;right:20px}[_nghost-%COMP%] {background:linear-gradient(180deg,#edf6ff,#fff);padding:10%}@media (min-width:992px){[_nghost-%COMP%] {padding:10% 0 0 0}}"];
export { styles as styles };
//# sourceMappingURL=share-certificate.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/progress/share-certificate/share-certificate.component.scss.shim.ngstyle.js
// module id = 1390
// module chunks = 27 28 29